// extracted by mini-css-extract-plugin
export default {"inputsContainer":"loginCredentialsForm_inputsContainer__RG91Y"};